





















import {Component, Vue} from 'vue-property-decorator';

@Component
export default class AdvancedTooltip extends Vue {
	public isUp: boolean = false;
	public fromTop: number = 50;
	public $refs: {
		advancedTooltip: HTMLElement,
	};

	public mounted() {
		const tooltip = this.$refs.advancedTooltip;
		if (tooltip) {
			const position = tooltip.getBoundingClientRect();
			const padding = 15;
			if (position.bottom > window.innerHeight - padding) {
				this.isUp = true;
				this.fromTop = -(position.height + padding);
				return;
			}
		}
		this.isUp = false;
	}
}
